const T = {
  // Brand darks , used for hero, footer, dark sections
  navy: "#0B1F3A",
  navyMid: "#122848",
  navyLight: "#1A3560",

  // Aqua accent , unchanged (text, icons, badges, glows)
  aqua: "#57D889",
  aquaDark: "#0B1F3A", // now navy/ink , no green text; was #089A8B
  aquaLight: "#57D889",
  aquaGhost: "#57d8883d",
  aquaGhost2: "#57d8881e",

  // Button accent , used ONLY for solid button backgrounds
  btnBg: "#6EE59E",
  btnBgHover: "#57D889",
  btnText: "#0B1F3A",

  // Light theme surfaces
  bg: "#F4F8FA",
  surface: "#FFFFFF",
  surfaceAlt: "#EBF3F6",

  // Text on light backgrounds
  ink: "#0B1F3A",
  inkMid: "#2A4A6B",
  muted: "#4E7080",
  slate: "#7A9BAE",

  // Borders
  border: "rgba(10, 191, 131, 0.25)",
  borderGray: "rgba(11,31,58,0.10)",

  white: "#FFFFFF",
};

export default T;
